export const AtgOrderConfirmation = {
  AtgOrderConfirmation: {
    confirmationOfOrder: 'Confirmation de commande :',
    thankYou: 'Merci pour votre commande!',
    invoiceHasBeenSentByEmail: 'Une facture vous a été envoyée par courriel. Vous devriez la recevoir sous peu.',
    orderItems: 'Articles de la commande',
    orderPlacedSuccessfully: 'Commande passée avec succès',
    createAccount: 'Créer un compte?',
    createAccountForNext: 'Créez un compte pour <{{email}}> afin de magasiner plus rapidement lors de votre prochaine visite.',
    replenishmentNumber: 'N° de réapprovisionnement',
    placedOn: 'Date de création de la commande',
    methodOfPayment: 'Mode de paiement',
    shippingMethod: 'Mode de livraison',
    purchaseOrderNumber: 'Numéro de bon de commande',
    status: 'Statut de la commande',
    active: 'Actif',
    cancelled: 'Annulée',
    frequency: 'Fréquence',
    nextOrderDate: 'Date de la prochaine commande',
    orderNumber: 'Numéro de commande',
    orderTotal: 'Total de la commande',
    totalQuantity: 'Quantité totale',
    totalItems: "Nombre total d'articles",
    orderType: 'Type de commande',
    jobName: 'Nom du travail',
    placedBy: 'Commande passée par',
    soldTo: 'Vendu à',
    reqDeliveryDate: 'Date de livraison demandée',
    copyHasBeenSentToEmail: 'Une copie de cette page vous a été envoyée par courriel à',
    specialInstructions: 'Instructions spéciales',
  },
};
